import React, { Dispatch, useEffect, useRef } from 'react';
import '../App.css';
import { IInject, IScenario, ITurnBrief } from '../interfaces';
import Modal from 'react-modal';
import { DebouncedFunc, isEmpty } from 'lodash';

interface InjectProps {
    isSelected: string;
    id: string;
    updateShowHide: Dispatch<any>;
    injectComponents: IInject[];
    setInjectComponents: Dispatch<IInject[]>;
    setInjectItem: Dispatch<IInject>;
    clickBranches:  Dispatch<any>;
    setZoomLevel: Dispatch<number>;
    zoomLevel: number;
    scenSnippets: string[];
    turn: number;
    setSnippetModalIsOpen: Dispatch<boolean>;
    setSelectedSnippet: Dispatch<number>;
    setNewSnippet: Dispatch<ITurnBrief>;
    setSelectedScenario: Dispatch<IScenario>;
    selectedScenario: IScenario;
    onChangeSave: DebouncedFunc<any>;
    showInjectMenu: string;
    setShowInjectMenu: Dispatch<string>;
  }

  export interface Item {
    id: number
    text: string
  }

  export interface coaArr {
    id: number
    text: string
  }

  Modal.setAppElement('#root');

  const isCloudStore = process.env.REACT_APP_IMAGE_SRC === 'cloud';

const RGLInject: React.FC<InjectProps> = ({ isSelected, setInjectComponents, id, injectComponents, updateShowHide, setInjectItem, clickBranches, setZoomLevel, zoomLevel, scenSnippets, turn, setSnippetModalIsOpen, setNewSnippet, setSelectedSnippet, selectedScenario, setSelectedScenario, onChangeSave, showInjectMenu, setShowInjectMenu }) => {

    const injectComponentsRef = useRef<IInject[]>([])
    useEffect(() => {
        injectComponentsRef.current = injectComponents;
    });

    const onChangeName = (ev: React.ChangeEvent<HTMLInputElement>) => {
        setInjectComponents(injectComponents.map((inject: IInject) => {
            if (inject.id === id.toString()) {
                return { ...inject, name: ev.currentTarget.value, isChanged: true };
            } else {
                return inject;
            }
        }));

        onChangeSave();
    }

    const nameKeyDown = (ev: React.KeyboardEvent<HTMLInputElement>) => {
        if (ev.key === 'Enter') {
            ev.currentTarget.blur()
        }
    }

    return (
      injectComponents.map((item, i) => {
        if (item.id === id) {
            if (!item.isEmpty) {
              const injImg = isCloudStore
                ? !isEmpty(item.image) ? item.imageUrl : null
                : !isEmpty(item.localImage) ? `data:image/png;base64, ${item.localImage}` : null;
              const injImgClass = injImg ? 'inject-image-png' : 'inject-exclaim-svg'
              return (
                <div className={`inject rgl-inject ${isSelected}`} data-id={id.toString()} key={item.id}>

                  <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '60px'}}>
                    {Array.from({length: item.turnLength}, (i, idx) => {
                      const turnInUse = item.nodes.findIndex((n) => n.turn === idx + 1) > -1;
                      return (
                        <div key={idx} className="in-use" style={{opacity: turnInUse ? 0 : 0.5}}>
                        </div>
                      )
                    })}
                  </div>

                  <div className="inject-content">
                    <div className="inject-exclaim" draggable="false">
                      <img src={injImg || 'img/inject-exclaim.svg'} className={injImgClass} alt="" draggable="false" />
                    </div>
                    <div className="inject-text">
                      <input className={`inject-title`} style={{'width': `min(${item.name.length + 2}ch * 1.12, 100% - 10px)`}} type="text" value={item.name} title={item.name} onChange={onChangeName} onKeyDown={nameKeyDown} key={i} data-id={item.id.toString()} size={item.name.length + 1} disabled={selectedScenario.published} />
                      
                      <div className="inject-detail">{item.turnLength} {item.turnLength > 1 ? 'Turns' : 'Turn'}, Starts Turn {item.startTurn}</div>
                    </div>
                  </div>
                  <img className="inject-more-detail" src="img/gray-ellipsis.svg" alt="detail" data-id={item.id.toString()} />
              </div>)
            } else {
              return (<div className="inject-empty" key={item.id}>
                Empty
              </div>)
            }
          } else {
            return <div key={item.id}></div>
          }
      })
    )
}

export default RGLInject;